export var BASE_SERVICE_STORE_PROPERTIES = {
    loading: false,
    error: null,
    initialized: false,
};
